<template>
  <div class="order-detail">
    <pageTitle :pageTitle="$t('lang.k_134001')"></pageTitle>
    <div class="version-info">
      <div class="version-item">
        <span></span>
        <h1>{{ $t('lang.k_134002') }}</h1>
        <p>
          {{ $t('lang.k_134003') }}
          <br />
          {{ $t('lang.k_134004') }}
        </p>
      </div>
      <div class="version-item">
        <span style="background: #5d81fb"></span>
        <h1 style="color: #5d81fb">{{ $t('lang.k_134005') }}</h1>
        <p>
          {{ $t('lang.k_134006') }}
          <br />
          {{ $t('lang.k_134007') }}
        </p>
        <h2 style="color: #5d81fb">{{ $t('lang.k_134008') }}</h2>
      </div>
      <div class="version-item">
        <span style="background: #fbb75d"></span>
        <h1 style="color: #fbb75d">{{ $t('lang.k_134009') }}</h1>
        <p>
          {{ $t('lang.k_134010') }}
          <br />
          {{ $t('lang.k_134011') }}
        </p>
        <h2 style="color: #fbb75d; border: 1px solid #fbb75d">{{ $t('lang.k_134012') }}</h2>
      </div>
    </div>
    <div class="version-card">
      <div class="version-list" v-for="(item, index) in versionList" :key="index">
        <div class="version-title">
          <div class="version-title-item" v-for="(items, indexs) in item.labelList" :key="indexs">
            {{ items.label }}
          </div>
        </div>
        <div class="version-list-text" v-for="(opt, optOndex) in item.textList" :key="optOndex">
          <div class="version-text-item">{{ opt.text }}</div>
          <div class="version-text-item"><i class="vh-icon-check" v-if="opt.isStandard"></i></div>
          <div class="version-text-item">
            <i class="vh-icon-check" v-if="opt.isProfessional"></i>
          </div>
          <div class="version-text-item"><i class="vh-icon-check" v-if="opt.isFlagship"></i></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import PageTitle from '@/components/PageTitle';
  export default {
    data() {
      return {
        versionList: [
          {
            labelList: [
              {
                label: this.$t('lang.k_134013')
              },
              {
                label: this.$t('lang.k_134002')
              },
              {
                label: this.$t('lang.k_134005')
              },
              {
                label: this.$t('lang.k_134009')
              }
            ],

            textList: [
              {
                text: this.$t('lang.k_134014'),
                isStandard: true,
                isFlagship: true,
                isProfessional: true
              },
              {
                text: this.$t('lang.k_134015'),
                isStandard: true,
                isFlagship: true,
                isProfessional: true
              },
              {
                text: this.$t('lang.k_134016'),
                isStandard: true,
                isFlagship: true,
                isProfessional: true
              },
              {
                text: this.$t('lang.k_134017'),
                isStandard: true,
                isFlagship: true,
                isProfessional: true
              },
              {
                text: this.$t('lang.k_134018'),
                isStandard: false,
                isFlagship: true,
                isProfessional: false
              },
              {
                text: this.$t('lang.k_134019'),
                isStandard: false,
                isFlagship: true,
                isProfessional: true
              },
              {
                text: this.$t('lang.k_134020'),
                isStandard: true,
                isFlagship: true,
                isProfessional: true
              },
              {
                text: this.$t('lang.k_134021'),
                isStandard: false,
                isFlagship: true,
                isProfessional: true
              }
            ]
          },
          {
            labelList: [
              {
                label: this.$t('lang.k_134022')
              },
              {
                label: ''
              },
              {
                label: ''
              },
              {
                label: ''
              }
            ],

            textList: [
              {
                text: this.$t('lang.k_134023'),
                isStandard: true,
                isFlagship: true,
                isProfessional: true
              },
              {
                text: this.$t('lang.k_134024'),
                isStandard: false,
                isFlagship: false,
                isProfessional: true
              },
              {
                text: this.$t('lang.k_134025'),
                isStandard: true,
                isFlagship: true,
                isProfessional: true
              }
            ]
          },
          {
            labelList: [
              {
                label: this.$t('lang.k_134026')
              },
              {
                label: ''
              },
              {
                label: ''
              },
              {
                label: ''
              }
            ],

            textList: [
              {
                text: this.$t('lang.k_134027'),
                isStandard: true,
                isFlagship: true,
                isProfessional: true
              },
              {
                text: this.$t('lang.k_134028'),
                isStandard: false,
                isFlagship: true,
                isProfessional: true
              },
              {
                text: this.$t('lang.k_134029'),
                isStandard: false,
                isFlagship: true,
                isProfessional: false
              }
            ]
          }
        ]
      };
    },
    components: {
      PageTitle
    }
  };
</script>
<style lang="less" scoped>
  .order-detail {
    width: 100%;
    .version-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .version-item {
        width: 32%;
        height: 248px;
        background: #fff;
        border: 4px;
        position: relative;
        text-align: center;
        padding: 40px 0;
        span {
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 4px;
          display: inline-block;
          width: 100%;
          height: 4px;
          background: #fc615b;
        }
        h1 {
          font-size: 32px;
          color: #fc615b;
          line-height: 40px;
          font-weight: 500;
          padding-bottom: 24px;
        }
        p {
          font-size: 14px;
          color: #666;
          line-height: 22px;
          font-weight: 400;
        }
        h2 {
          width: 152px;
          height: 40px;
          line-height: 40px;
          border-radius: 20px;
          border: 1px solid #5d81fb;
          margin: auto;
          margin-top: 20px;
          cursor: pointer;
        }
      }
    }
    .version-card {
      margin-top: 40px;
      background: #fff;
      padding: 24px;
      // .version-list{
      //   // padding: 24px;
      // }
      .version-title,
      .version-list-text {
        height: 64px;
        background: #f7f7f7;
        line-height: 64px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .version-title-item {
          width: 25%;
          text-align: center;
          font-size: 18px;
          color: #1a1a1a;
          font-weight: 600;
          &:first-child {
            text-align: left;
            padding-left: 24px;
          }
        }
      }
      .version-list-text {
        background: #fff;
        border-bottom: 1px solid #e6e6e6;
        .version-text-item {
          width: 25%;
          // border: 1px solid #ccc;
          color: #1a1a1a;
          font-size: 14px;
          text-align: center;
          // border-bottom: 1px solid #E6E6E6;
          i {
            color: #fb3a32;
            font-size: 20px;
            font-weight: bolder;
          }
          &:first-child {
            text-align: left;
            padding-left: 24px;
          }
        }
        &:last-child {
          border: 0;
        }
      }
    }
  }
</style>
